import { Button, CloseButton, Col, Modal, Row } from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import CheckIcon from '@mui/icons-material/CheckCircle';
import Stack from 'react-bootstrap/Stack';
import { STATUSES, DEFAULT_STATE_VALUE,WindowState } from "Utils/constants";
import { PageInfo } from "Components/PageInformation/PageInformation";


const DynamicPopup = ({
  showPopup,
  handleClose,
  buttons,
  title,
  children
}) => {

  const modalBody = (variant) => {
        return (
            <PageInfo 
                type="confirm" 
                message={
                    children
                }
            ></PageInfo>
        );
  }

  return (
    <>
      <Modal className="modal" size="lg" backdrop="static" keyboard={false} show={showPopup} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title >{title}</Modal.Title>
          <CloseButton className="align-self-start" onClick={handleClose}></CloseButton>
        </Modal.Header>
        <Modal.Body>
          {
            modalBody()
          }
        </Modal.Body>
        <Modal.Footer>
            {buttons.map((b, index) => (
                <Button key={index} onClick={b.action} variant={b.style=="outline" ? "popup-cancel" : "popup-confirm"}>
                    {b.text}
                </Button>
            ))}
          
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default DynamicPopup;